import HeroSection from '../components/sections/HeroSection';
import AboutPageSections from '../components/sections/AboutPageSections';
import WhyChooseUsSection from '../components/sections/WhyChooseUsSection';
import OtherServicesSection from '../components/sections/OtherServicesSection';
import EmpoweringSection from '../components/sections/EmpoweringSection';
import SolutionsIntroSection from '../components/sections/SolutionsIntroSection';
import PartnerStatementSection from '../components/sections/PartnerStatementSection';
import ContactSection from '../components/sections/ContactSection';
import JoinTeamSection from '../components/sections/JoinTeamSection';
import { useAppDispatch } from '../store/hook';
import { useEffect } from 'react';
import { authenticate } from '../utils/authApi';

const LandingPage = () => {

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(authenticate());
  }, [dispatch])

  return (
    <>
      <SolutionsIntroSection />
      <HeroSection />
      <WhyChooseUsSection />
      <EmpoweringSection />
      <OtherServicesSection />
      <PartnerStatementSection />
      <AboutPageSections />
      <ContactSection />
      <JoinTeamSection />
    </>
  );
};

export default LandingPage;
